/* ==========================================================================
   HOMEPAGE HERO — THE MODELLE MEGA PRICE DROP
   Load state and scroll cue. The scrolling ribbon is driven by the shared
   price-drop-marquee.js. No external dependencies.
   ========================================================================== */

(function () {
  'use strict';

  var HERO_SELECTOR = '[data-mpd-hero]';
  var SCROLL_SELECTOR = '[data-mpd-scroll]';

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initHero(hero) {
    if (!hero || hero.dataset.mpdReady === 'true') return;
    hero.dataset.mpdReady = 'true';

    var image = hero.querySelector('.mpd-hero__image');
    var reveal = function () {
      window.requestAnimationFrame(function () {
        hero.classList.add('is-loaded');
      });
    };

    if (prefersReducedMotion() || hero.dataset.mpdAnimate !== 'true') {
      hero.classList.add('is-loaded');
    } else if (image && !image.complete) {
      image.addEventListener('load', reveal, { once: true });
      image.addEventListener('error', reveal, { once: true });
    } else {
      reveal();
    }

    var scrollButton = hero.querySelector(SCROLL_SELECTOR);
    if (scrollButton) {
      scrollButton.addEventListener('click', function () {
        var next = hero.closest('.shopify-section')
          ? hero.closest('.shopify-section').nextElementSibling
          : hero.parentElement && hero.parentElement.nextElementSibling;

        if (!next) return;

        var top = next.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({ top: top, behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
      });
    }
  }

  function initAll() {
    document.querySelectorAll(HERO_SELECTOR).forEach(initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event || !event.target) return;
    var hero = event.target.matches && event.target.matches(HERO_SELECTOR)
      ? event.target
      : event.target.querySelector(HERO_SELECTOR);
    initHero(hero);
  });
})();
